import { apiFetch } from "../api";
import React, { useState, useEffect } from "react";
export default function AlertsPanel({ coin, price }) {
  const [alerts,setSel]=useState([]); const [dir,setDir]=useState("above");
  const [target,setTarget]=useState(""); const [label,setLabel]=useState(""); const [msg,setMsg]=useState("");
  const load=()=>apiFetch(`/api/alerts?coin=${coin}`).then(r=>r.json()).then(d=>setSel(d.alerts||[])).catch(()=>{});
  useEffect(()=>{load();},[coin]);
  const add=async()=>{
    const p=parseFloat(target); if(!p||isNaN(p)){setMsg("올바른 가격을 입력해줘!");return;}
    const r=await apiFetch("/api/alerts",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({coin,direction:dir,price:p,label})}).then(r=>r.json());
    setMsg(r.message||"등록됨!"); setTarget(""); setLabel(""); load(); setTimeout(()=>setMsg(""),3000);
  };
  const del=async(id)=>{await apiFetch(`/api/alerts/${id}`,{method:"DELETE"});load();};
  return (
    <div style={{display:"flex",flexDirection:"column",gap:12}}>
      {price&&<p style={{fontSize:12,color:"#6b7280"}}>{coin} 현재가: <span style={{color:"#e2e6f0",fontWeight:700}}>${price.toLocaleString()}</span></p>}
      <div style={{display:"flex",gap:6}}>
        {["above","below"].map(d=>(
          <button key={d} onClick={()=>setDir(d)} style={{flex:1,padding:"7px 0",borderRadius:8,cursor:"pointer",fontSize:13,fontWeight:700,
            background:dir===d?(d==="above"?"rgba(34,197,94,.2)":"rgba(239,68,68,.2)"):"#181c24",
            border:dir===d?`1.5px solid ${d==="above"?"#22c55e":"#ef4444"}`:"1px solid #1e2433",
            color:dir===d?(d==="above"?"#22c55e":"#ef4444"):"#6b7280"}}>
            {d==="above"?"▲ 이상":"▼ 이하"}
          </button>
        ))}
      </div>
      <input type="number" placeholder="목표 가격" value={target} onChange={e=>setTarget(e.target.value)}
        style={{padding:"8px 12px",borderRadius:8,fontSize:13,background:"#181c24",border:"1px solid #1e2433",color:"#e2e6f0",outline:"none",width:"100%"}}/>
      <input type="text" placeholder="메모 (선택)" value={label} onChange={e=>setLabel(e.target.value)}
        style={{padding:"8px 12px",borderRadius:8,fontSize:13,background:"#181c24",border:"1px solid #1e2433",color:"#e2e6f0",outline:"none",width:"100%"}}/>
      <button onClick={add} style={{padding:"9px 0",borderRadius:8,cursor:"pointer",background:"#3b82f6",border:"none",color:"#fff",fontWeight:700,fontSize:13}}>🔔 알림 추가</button>
      {msg&&<p style={{fontSize:12,color:"#22c55e",textAlign:"center"}}>{msg}</p>}
      {alerts.map(a=>(
        <div key={a.id} style={{display:"flex",justifyContent:"space-between",alignItems:"center",
          padding:"7px 10px",background:"#181c24",borderRadius:8,border:"1px solid #1e2433"}}>
          <div>
            <span style={{fontSize:12,fontWeight:700,color:a.direction==="above"?"#22c55e":"#ef4444",marginRight:6}}>
              {a.direction==="above"?"▲":"▼"}
            </span>
            <span style={{fontSize:13,fontWeight:600}}>${parseFloat(a.price).toLocaleString()}</span>
            {a.label&&<span style={{fontSize:11,color:"#6b7280",marginLeft:6}}>{a.label}</span>}
          </div>
          <button onClick={()=>del(a.id)} style={{background:"none",border:"none",color:"#4b5563",cursor:"pointer",fontSize:16}}>×</button>
        </div>
      ))}
    </div>
  );
}
